import { InlineMessage } from '@strata/react-inline-message';

import { PersonaBox } from 'components/designSystem/personas/PersonaBox';
import { Columns } from 'components/shared/Columns';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const internalApplications = [
    <h3 key="1">Agora and Lucent</h3>,
    <Columns
        key="2"
        columns={Columns.ColumnNumber.THREE}
        content={
            <>
                <PersonaBox
                    applicationType={PersonaBox.Types.INTERNAL}
                    personaType={PersonaBox.Persona.REFERRAL_OPS}
                    title="Referral Operations"
                    description="Referral Operations is in charge of getting referrals efficiently assigned and managed by pharmacies with the goal of enabling better patient outcomes."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Referral-Ops.pdf"
                />
                <PersonaBox
                    applicationType={PersonaBox.Types.INTERNAL}
                    personaType={PersonaBox.Persona.CSM}
                    title="Customer Success Manager"
                    description="The CSM is responsible for all aspects of managing and maintaining pharmacy customer accounts, as well as ensuring a healthy network of pharmacies through training and on-going communication."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Customer-Success-Manager.pdf"
                />
                <PersonaBox
                    applicationType={PersonaBox.Types.INTERNAL}
                    personaType={PersonaBox.Persona.PHARMACY_OPS}
                    title="Pharmacy Operations"
                    description="Pharmacy Operations addresses escalations, corrects data discrepancies in member data, and ensures the prompt and accurate submission of claims by pharmacies."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Pharmacy-Ops.pdf"
                />
            </>
        }
    />,
];
const externalApplications = [
    <h3 key="3">FMH for Pharmacies</h3>,
    <Columns
        key="4"
        columns={Columns.ColumnNumber.THREE}
        content={
            <>
                <PersonaBox
                    applicationType={PersonaBox.Types.PHARMACY}
                    personaType={PersonaBox.Persona.LARGE_PHARMACY_STRATEGIC}
                    title="Large Pharmacy: Strategic Partner"
                    description="The strategic partner of a large pharmacy oversees application engagement and performance. They guide their team in leveraging the platform to achieve success."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Large-Strategic.pdf"
                />
                <PersonaBox
                    applicationType={PersonaBox.Types.PHARMACY}
                    personaType={PersonaBox.Persona.LARGE_PHARMACY_FINANCE}
                    title="Large Pharmacy: Finance Manager"
                    description="The Finance Manager of a large pharmacy is responsible for obtaining referrals at the best rate. They monitor the performance of the automation templates, and accept pending referrals."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Large-Finance-Manager.pdf"
                />
                <PersonaBox
                    applicationType={PersonaBox.Types.PHARMACY}
                    personaType={PersonaBox.Persona.LARGE_PHARMACY_PHARMACIST}
                    title="Large Pharmacy: Pharmacist/Technician"
                    description="The Pharmacist/Technician of a large pharmacy is responsible for coordinating patient care and diligently managing the prescription delivery process, while ensuring accurate medical claims submission."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Large-Pharmacist.pdf"
                />
                <PersonaBox
                    applicationType={PersonaBox.Types.PHARMACY}
                    personaType={PersonaBox.Persona.SMALL_PHARMACY_OWNER}
                    title="Small Pharmacy: Owner/Operator"
                    description="The owner/operator of a small pharmacy performs all responsibilities in the platform. This includes training, configuring automation rules, reviewing referrals, bidding on referrals, and rebilling."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Small-Owner:Operator.pdf"
                />
                <PersonaBox
                    applicationType={PersonaBox.Types.PHARMACY}
                    personaType={PersonaBox.Persona.SMALL_PHARMACY_PHARMACIST}
                    title="Small Pharmacy: Pharmacist/Technician"
                    description="The pharmacist/Technician of a small pharmacy provides optimal patient care and is in charge of completing worklist tasks and submitting claims."
                    navUrl="https://sseasacdn.blob.core.windows.net/strata-website/Persona-Small-Pharmacist.pdf"
                />
            </>
        }
    />,
];

export const Personas = () => (
    <div>
        <Page
            pageTitle="Personas"
            pageDescription={
                <>
                    <p>
                        Our personas are archetypes that embody traits and qualities of real users.
                        They contain real data gathered through user research such as goals and pain
                        points that users have in relation to the application and their roles.
                        Personas help with understanding typical users, can be integrated into
                        stories, and ultimetly result in better design decisions.
                    </p>
                    <p>
                        As the applications continue to develop, these personas will undergo
                        continuous evolution and refinement.
                    </p>
                    <div style={{ fontSize: '16px' }}>
                        <InlineMessage
                            intent={InlineMessage.Intent.INFO}
                            label="Personas for the other FMH applications are currently being worked on."
                        />
                    </div>
                </>
            }
            pageContent={
                <>
                    <Section title="Internal Applications" contentArray={internalApplications} />
                    <Section title="External Applications" contentArray={externalApplications} />
                </>
            }
        />
    </div>
);
